// extracted by mini-css-extract-plugin
module.exports = {"modal":"jgp-22GyD","modalTitle":"jgp-2xwZ7","topContainer":"jgp-1E9o4","shareButton":"jgp-3vSrF"};